import { render } from "./InvitationConfirmModal.vue?vue&type=template&id=e34ed3d2&scoped=true&ts=true"
import script from "./InvitationConfirmModal.vue?vue&type=script&lang=ts"
export * from "./InvitationConfirmModal.vue?vue&type=script&lang=ts"

import "./InvitationConfirmModal.vue?vue&type=style&index=0&id=e34ed3d2&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e34ed3d2"]])

export default __exports__